// components/HomeBanner.jsx

const HomeBanner = ({ lang, page, pageEn }) => {
  const content = page;
  const fallbackContent = lang !== "en" ? pageEn : null;

  const mainImg = content?.banner_main_image || fallbackContent?.banner_main_image;

  const getImageUrl = (img) => {
    if (!img) return "/fallback.jpg";

    return (
      process.env.REACT_APP_Base_URL +
      (img?.url || "")
    );
  };

  return (
    <section>
      <div className="relative h-[100dvh] overflow-hidden">
        {mainImg && (
          <img
            src={getImageUrl(mainImg)}
            alt={mainImg?.alternativeText || "Saison Capital"}
            className="banner-img-reveal block"
            fetchPriority="high"
            loading="eager"
            decoding="async"
          />
        )}

        <h1 className="banner-text padding-x-40 w-[100%] md:w-[80%]">
          {content?.banner_text ||
            fallbackContent?.banner_text ||
            ""}
        </h1>
      </div>
    </section>
  );
};

export default HomeBanner;
